import axios from 'axios'


let  baseConfig = axios.create({
  baseURL: '/api/',
  timeout: 30000
})


export default baseConfig




// WEBPACK FOOTER //
// ./src/api/config.js